import { Heart } from "lucide-react";

export default function Footer() {
  return (
    <footer data-testid="site-footer" className="relative border-t border-[rgba(197,165,90,0.15)] pt-14 pb-28 sm:pb-24 mt-10">
      <div className="max-w-7xl mx-auto px-5 sm:px-8 lg:px-12 grid md:grid-cols-3 gap-10 items-start">
        <div>
          <div className="flex items-center gap-3">
            <span className="inline-flex h-9 w-9 items-center justify-center rounded-full border border-[rgba(212,175,55,0.4)]">
              <Heart size={16} className="text-[#D4AF37]" />
            </span>
            <div>
              <div className="serif text-[20px] text-[#F5F0E8]">Eternal Legacy</div>
              <div className="overline text-[9px] text-[#C5A55A]/80">Tributes</div>
            </div>
          </div>
          <p className="mt-5 text-sm text-[#A0988E] spectral leading-relaxed max-w-xs">
            Hand-finished cinematic memorial tribute films. Serving families worldwide.
          </p>
        </div>

        <div>
          <div className="overline mb-4">Explore</div>
          <ul className="space-y-2.5 text-sm text-[#A0988E]">
            <li><a href="#work" className="hover:text-[#F5F0E8]">Our Work</a></li>
            <li><a href="#process" className="hover:text-[#F5F0E8]">Process</a></li>
            <li><a href="#pricing" className="hover:text-[#F5F0E8]">Pricing</a></li>
            <li><a href="#faq" className="hover:text-[#F5F0E8]">FAQ</a></li>
          </ul>
        </div>

        <div>
          <div className="overline mb-4">Our Pledge</div>
          <p className="text-sm text-[#A0988E] spectral italic leading-relaxed">
            Hand-finished with care. Delivered on time. Treated with the quiet
            reverence your family deserves.
          </p>
        </div>
      </div>

      <div className="max-w-7xl mx-auto px-5 sm:px-8 lg:px-12 mt-10 pt-6 border-t border-[rgba(197,165,90,0.1)] flex items-center justify-between flex-wrap gap-4">
        <p className="text-xs text-[#A0988E]">© {new Date().getFullYear()} Eternal Legacy Tributes. In loving memory.</p>
        <p className="text-xs text-[#A0988E]">
          Made with care, frame by frame. <a href="/owner" data-testid="owner-sign-in-link" className="ml-3 text-[#A0988E]/60 hover:text-[#F5F0E8]">Owner sign in</a>
        </p>
      </div>
    </footer>
  );
}
